(function () {
  const styleText = `
    form[data-testid="form"],
    form[class*="_formFieldset_"] {
      display: grid !important;
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      gap: 12px !important;
    }
    form[data-testid="form"] > div:first-child,
    form[data-testid="form"] > button,
    form[class*="_formFieldset_"] > div:first-child,
    form[class*="_formFieldset_"] > button {
      grid-column: 1 / -1 !important;
    }
    form[data-testid="form"] > button,
    form[class*="_formFieldset_"] > button {
      box-sizing: border-box !important;
      width: 100% !important;
    }
    form[data-testid="form"] > div:has(input[data-testid="field-first_name"]),
    form[data-testid="form"] > div:has(input[data-testid="field-email"]),
    form[class*="_formFieldset_"] > div:has(input) {
      grid-column: span 1 !important;
    }
    /* Shopify Forms reserves space for an empty internal heading. Keep the
       fields close to the reservation label while retaining the form layout. */
    [class*="_formHeader_"] {
      height: 0 !important;
      min-height: 0 !important;
      margin: 0 !important;
      overflow: hidden !important;
    }
    [class*="_gridItemContent_"] {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
    @media (max-width: 1023px) {
      :host,
      #app-embed,
      #app-embed > *,
      #app-embed section,
      #app-embed div,
      [class*="_container_"],
      [class*="_formContainer_"],
      [class*="_gridItemContent_"],
      form[data-testid="form"],
      form[class*="_formFieldset_"] {
        width: 100% !important;
        max-width: none !important;
      }
      [class*="_container_"],
      [class*="_inline_"],
      [class*="_formContainer_"],
      [class*="_gridItem_"],
      [class*="_gridItemContent_"] {
        display: block !important;
        min-width: 0 !important;
        grid-template-columns: minmax(0, 1fr) !important;
        grid-column: 1 / -1 !important;
        justify-self: stretch !important;
      }
      form[data-testid="form"] > *,
      form[class*="_formFieldset_"] > * {
        width: 100% !important;
        max-width: none !important;
        grid-column: 1 / -1 !important;
      }
    }
    @media (max-width: 1023px) {
      form[data-testid="form"],
      form[class*="_formFieldset_"] {
        grid-template-columns: 1fr !important;
      }
      form[data-testid="form"] > div:has(input[data-testid="field-first_name"]),
      form[data-testid="form"] > div:has(input[data-testid="field-email"]),
      form[class*="_formFieldset_"] > div:has(input) {
        grid-column: 1 / -1 !important;
      }
    }
  `;

  function applyFormLayout() {
    document.querySelectorAll('shopify-forms-embed').forEach((host) => {
      const root = host.shadowRoot;
      if (!root) return;
      if (!root.querySelector('[data-velori-form-layout]')) {
        const style = document.createElement('style');
        style.dataset.veloriFormLayout = 'true';
        style.textContent = styleText;
        root.appendChild(style);
      }
      if (!host.__veloriFormObserver) {
        host.__veloriFormObserver = new MutationObserver(applyFormLayout);
        host.__veloriFormObserver.observe(root, { childList: true, subtree: true });
      }

      const form = root.querySelector('form[data-testid="form"], form[class*="_formFieldset_"]');
      const widthTargets = [
        host,
        root.querySelector('#app-embed'),
        root.querySelector('[class*="_container_"]'),
        root.querySelector('[class*="_formContainer_"]'),
        root.querySelector('[class*="_gridItemContent_"]'),
        ...root.querySelectorAll('[class*="_inline_"], [class*="_grid_"], [class*="_gridItem_"]'),
        form,
      ].filter(Boolean);
      const isMobile = window.matchMedia('(max-width: 1023px)').matches;
      if (form) {
        let ancestor = form.parentElement;
        while (ancestor && ancestor !== root) {
          widthTargets.push(ancestor);
          ancestor = ancestor.parentElement;
        }
      }
      widthTargets.forEach((element) => {
        if (isMobile) {
          element.style.setProperty('width', '100%', 'important');
          element.style.setProperty('max-width', 'none', 'important');
          element.style.setProperty('margin-left', '0', 'important');
          element.style.setProperty('margin-right', '0', 'important');
          element.style.setProperty('overflow', 'visible', 'important');
        } else {
          element.style.removeProperty('width');
          element.style.removeProperty('max-width');
          element.style.removeProperty('margin-left');
          element.style.removeProperty('margin-right');
          element.style.removeProperty('overflow');
        }
      });
      if (form && isMobile) {
        form.style.setProperty('grid-template-columns', '1fr', 'important');
        [...form.children].forEach((field) => {
          field.style.setProperty('width', '100%', 'important');
          field.style.setProperty('max-width', 'none', 'important');
          field.style.setProperty('grid-column', '1 / -1', 'important');
        });
      }
    });
  }

  applyFormLayout();
  document.addEventListener('DOMContentLoaded', applyFormLayout, { once: true });
  window.addEventListener('resize', applyFormLayout);
  new MutationObserver(applyFormLayout).observe(document.documentElement, { childList: true, subtree: true });
})();
